module.exports = __webpack_public_path__ + "media/images/529s/apple-touch-icon-120x120-84d110016cc1a5574f05b9d9bba3d04f.png";